import { handleActions } from 'redux-actions'
import {
  SET_CATALOG_DATA,
  SET_CATALOG_STATE
} from '../constants/mallConstant'
import { handleStateChange } from '../utils'

const initState = {
  loading: false,
  errorMessage: '',
  data: [],
  categories: [],
  labels: []
}

export const mallCatalogs = handleActions({
  [SET_CATALOG_DATA]: (state, action) => {
    let newState = {}
    Object.assign(newState, state, {
      loading: false,
      errorMessage: '',
      categories: action.payload.list
    })
    return newState
  },
  [SET_CATALOG_STATE]: handleStateChange
}, initState)
